import api from "./Api";

export default class LoteService {
  gerarDeclaracaoLote(request) {
    if (request) {
      return api.get(this.host() + "/api/v1/frete/declaracao-conteudo/lote?uuids=" + request, {
        responseType: "blob",
      });
    }
  }

  gerarComprovantePostagem(format, uuids) {
    const params = new URLSearchParams();
    params.append("format", format);
    params.append("uuids", uuids.join(","));

    return api.get(this.host() + "/api/v1/frete/comprovante-postagem", {
      params,
      responseType: "blob",
    });
  }

  host() {
    return process.env.REACT_APP_HOST_API;
  }
}
